import React from "react";
import {isSet,isObject} from '../../../../utils/commonUtils';
import { Link } from "react-router-dom";
import NewTHeader from "./NewTHeader";
import NewAction from "./NewAction";
import NewCheckbox from "./NewCheckbox";
import NewFormInput from "./NewFormInput";
import NewFileType from "./NewFileType";
import NewHyperLink from "./NewHyperLink";
import NewDragHandler from "./NewDragHandler";
import NewFieldEdit from "./NewFieldEdit";
import NewProgressBar from "./NewProgressBar";

const NewTableData =(props)=>{
    const {Tag} = props;
    switch (isSet(props.type,'')) {
        case "THeader":
            return <NewTHeader {...props} />  
        case "Actions":
            return <NewAction {...props}  />
        case "checkBox":
            return <NewCheckbox {...props}/>
        case "FormInput":
            return <NewFormInput {...props} />
        case "FileType":
            return <NewFileType {...props} />
        case "HyperLink":
            return <NewHyperLink {...props} />
        case "DragHandler":
            return <NewDragHandler {...props} />
        case "FieldEdit":
            return <NewFieldEdit {...props} />
        case "ProgressBar":
            return <NewProgressBar {...props} />
        default:
            let disValue = props.value;
            let attrbs = {};
            let objTitle = '';
            if(isObject(props.value)){
                disValue = props.value.value;
                objTitle = isSet(props.value.title,'')
                attrbs = isSet(props.value.attributes,{});
            }
            const title = isObject(isSet(disValue,''))?objTitle:isSet(disValue,'');
            const cellClass = props.noTruncate ? 'sh_tableCellWrap' : (props.cellClassName !== undefined ? props.cellClassName : 'forTable_textEllipsis');
            return <Tag class={cellClass} key={"column"} title={title} {...attrbs}>
                {props.value && props.value.clickHandler ?
                <span onClick={props.value.clickHandler}>{isSet(disValue,'')}</span>:
                props.value && props.value.href?
                <Link style={{color:'inherit',textDecoration:'none' }} to={props.value.href}>{isSet(disValue,'')}</Link>
                :isSet(disValue,'')}
                </Tag>
    }
}

NewTableData.defaultProps = {
    Tag:'td',
    attributes:{},
    PrependElement:<></>
}
export default NewTableData;

